import React from 'react';
import '../../App.css';
import HeroSection from '../HeroSection';
import Footer from '../Footer';
import NavCardItem from '../NavCardItem';

function Home() {
  return (
    <>
      <HeroSection />

      <div className='navcards'>
        <h1>Explore Our Site</h1>
        <div className='navcards__container'>
          <NavCardItem src='images/mugs4.jpg' title='Gallery' path='/products' />
          <NavCardItem src='images/tools.jpg' title='Classes' path='/services' />
          <NavCardItem src='images/the_artist.jpg' title='Artist' path='/about' />
          <NavCardItem src='images/exhibit.jpg' title='Cart' path='/sign-up' />
        </div>
      </div>

      <Footer />
    </>
  );
}

export default Home;